const accountScope = {
  name: 'Account scope',
  permission: 'account variables'
};

export default accountScope;
